module.exports = __webpack_public_path__ + "static/media/train.de5ee2f2.jpg";